import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { LinkButton } from '../../Link/LinkButton/index.js';
import { useMenuItem } from '../useMenuItem/useMenuItem.js';

var MenuLink = function MenuLink(_a) {
    var onClick = _a.onClick, id = _a.id, disabled = _a.disabled, selected = _a.selected, _b = _a.themeKey, themeKey = _b === void 0 ? "menuItem" : _b, props = __rest(_a, ["onClick", "id", "disabled", "selected", "themeKey"]);
    var menuItemProps = useMenuItem({
        onClick: onClick,
        id: id,
        disabled: disabled,
        selected: selected,
    }).props;
    return jsx(LinkButton, __assign({ themeKey: themeKey }, menuItemProps, props));
};

export { MenuLink };
//# sourceMappingURL=MenuLink.js.map
